export default __webpack_public_path__ + "img/egelvGMk.64ad8ab6.svg";